import { gql } from '@apollo/client'
import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { useConfirmDialog, useError, useMutation } from '@ztechapps/common.hook'

export const RevokeButton = (props) => {
  const { onError } = useError()
  const { loginToken, disabled, disabledReason } = props
  const [onDelete] = useMutation({ query, options: { mutationOptions: { refetchQueries: ['getApiLoginTokens'] } } })
  const { confirm } = useConfirmDialog({
    text: `Are you sure you remove this access token?`,
    title: 'Remove access token?',
    buttons: { confirm: { text: 'Yes, remove it!' } },
  })
  const onClick = async () => {
    try {
      const filter = { hashedToken: loginToken.hashedToken }
      await confirm(() =>
        onDelete({
          filter,
        })
      )
    } catch (e) {
      onError(e)
    }
  }

  return (
    <BusyButton
      bsStyle="danger"
      disabled={disabled}
      disabledReason={disabled ? disabledReason : undefined}
      text="Revoke"
      title="Remove the selected personal access token"
      icon="undo"
      onClick={onClick}
    />
  )
}

const query = gql(`
  mutation deleteApiLoginToken($filter: JSON!) {
    deleteApiLoginToken(filter: $filter) {
        hashedToken
        when
        name
        scope
    }
  }
`)
